export default "__VITE_ASSET__CozM7qVi__"